import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Check } from 'lucide-react'
import { Checkbox } from '../../ui/checkbox'
import { Input } from '../../ui/input'

function ClassPackageMultiSelect({ packages, onChange }) {
  const [search, setSearch] = useState('')

  const safePackages = packages || []

  const selectedPackages = safePackages.filter((p) => p.selected)
  const filteredPackages = safePackages.filter((p) => p.label?.toLowerCase().includes(search.toLowerCase()))

  function handleToggle(pkg) {
    const updatedPackages = safePackages.map((p) => (p.id === pkg.id ? { ...p, selected: !p.selected } : p))
    onChange(updatedPackages)
  }

  return (
    <div className="space-y-3">
      <Input
        placeholder="Search packages..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="h-9"
      />

      {selectedPackages.length > 0 && (
        <div className="flex items-center gap-2 flex-wrap p-2 bg-gray-50 rounded-md">
          {selectedPackages.map((pkg) => (
            <div key={pkg.id} className="flex items-center gap-1 bg-white rounded px-2 py-1 border border-gray-200">
              <span className="text-xs text-gray-900">{pkg.label}</span>
            </div>
          ))}
        </div>
      )}

      <div className="max-h-[300px] overflow-y-auto border border-gray-200 rounded-md">
        {filteredPackages.length === 0 ? (
          <div className="text-center py-4 text-gray-500 text-sm">No packages found</div>
        ) : (
          <div className="divide-y divide-gray-200">
            {filteredPackages.map((pkg) => {
              const isSelected = pkg.selected
              return (
                <div
                  key={pkg.id}
                  className="flex items-center space-x-2 p-3 hover:bg-gray-50 cursor-pointer"
                  onClick={() => handleToggle(pkg)}
                >
                  <Checkbox checked={isSelected} />
                  <span className="flex-1 text-sm text-gray-900">{pkg.label}</span>
                  {isSelected && <Check className="h-4 w-4 text-green-600" />}
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

ClassPackageMultiSelect.propTypes = {
  packages: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
}

export default ClassPackageMultiSelect
